import { NavLink, useLocation } from 'react-router';

import { cn } from '@/lib/utils';
import { orgPath, stripOrgPrefix } from '@/utils/org-path';
import {
  resolveActiveSection,
  useNavSections,
} from '@/components/navigation/use-nav-sections';

/**
 * The panel the design pairs with a grouped taskbar destination. It sits beside
 * the rail and stays put while you move around the section, rather than opening
 * and closing like a menu.
 */
export function NavSectionPanel() {
  const pathname = stripOrgPrefix(useLocation().pathname);
  const sections = useNavSections();
  const activeSection = resolveActiveSection(sections, pathname);

  if (!activeSection) {
    return null;
  }

  return (
    <aside
      data-nav-section-panel={activeSection.id}
      aria-label={activeSection.title}
      className='nav-section-divider -ml-px hidden w-[304px] shrink-0 flex-col border-l border-r border-r-sidebar-border bg-sidebar text-sidebar-foreground md:flex'
    >
      <nav className='subtle-scrollbar flex min-h-0 flex-1 flex-col gap-1 overflow-y-auto p-2'>
        {activeSection.items.map(({ id, label, to, icon: Icon }) => (
          <NavLink
            key={id}
            id={id}
            to={orgPath(to)}
            className={({ isActive }) =>
              cn(
                'flex h-8 items-center gap-2 rounded-md px-2 text-sm outline-none ring-sidebar-ring transition-colors',
                'hover:bg-sidebar-accent hover:text-sidebar-accent-foreground focus-visible:ring-2',
                isActive &&
                  'bg-sidebar-accent font-medium text-sidebar-accent-foreground',
              )
            }
          >
            <Icon className='size-4 shrink-0' />
            <span className='truncate'>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
